import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Components
import HamburgerIcon from '@icons/HamburgerIcon';
import Popover from '@atoms/Popover';
import { LinkSmall, LabelSmall, Ul } from '@styled';

// Functionality
import colors from '@general/colors';
import useClickOutside from '@hooks/useClickOutside';

const PopoverInner = styled.div`
    padding: 8px 16px;
`;

const Dot = styled.span`
    background: ${colors.azure};
    border-radius: 12px;
    display: inline-block;
    height: 5px;
    margin-bottom: 1px;
    margin-right: 4px;
    width: 5px;
`;

const PopoverSelect = ({ placeholder, options, optionIdProp, optionLabelProp, selectedOption, onSelect }) => {
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);

    useClickOutside({ ref: containerRef, onClickOutside: () => setIsOpen(false) });

    return (
        <div className="relative" ref={containerRef}>
            <LinkSmall
                className="align-items-center cursor-pointer d-flex text-primary whitespace-nowrap"
                onClick={() => setIsOpen(!isOpen)}
            >
                <span className="mr-0.5rem">{placeholder}</span>
                <HamburgerIcon color={colors.primary} />
            </LinkSmall>

            <Popover isOpen={isOpen} arrowRight={22} bodyRight={0} bodyTop={34}>
                <PopoverInner>
                    <Ul className="m-0">
                        {options.map(option => {
                            const isSelected = selectedOption && option[optionIdProp] === selectedOption[optionIdProp];

                            return (
                                <li key={option[optionIdProp]} className="whitespace-nowrap">
                                    {isSelected && (
                                        <>
                                            <Dot />
                                            <LabelSmall className="font-bold">{option[optionLabelProp]}</LabelSmall>
                                        </>
                                    )}

                                    {!isSelected && (
                                        <a
                                            href="#"
                                            className="cursor-pointer"
                                            style={{ marginLeft: '9px' }}
                                            onClick={e => {
                                                e.preventDefault();
                                                setIsOpen(false);
                                                onSelect(option);
                                            }}
                                        >
                                            <LabelSmall>{option[optionLabelProp]}</LabelSmall>
                                        </a>
                                    )}
                                </li>
                            );
                        })}
                    </Ul>
                </PopoverInner>
            </Popover>
        </div>
    );
};

PopoverSelect.propTypes = {
    placeholder: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    optionIdProp: PropTypes.string.isRequired,
    optionLabelProp: PropTypes.string.isRequired,
    selectedOption: PropTypes.object,
    onSelect: PropTypes.func,
};

export default PopoverSelect;
